/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Chinese (Traditional)
export default {
  'confluence-table-tree.column.contributors': '參與者',
  'confluence-table-tree.column.last-modified': '上次修改',
  'confluence-table-tree.column.title': '名稱',
  'confluence-table-tree.could-not-load': '無法載入',
  'confluence-table-tree.could-not-load-contributors': '無法載入參與者',
  'confluence-table-tree.create-child-page': '建立子系頁面',
  'confluence-table-tree.create-page': '建立頁面',
  'confluence-table-tree.default.page.title': '未命名',
  'confluence-table-tree.default.show-all-pages-button.label': '顯示更多頁面',
  'confluence-table-tree.draft.lozenge': '草稿',
  'confluence-table-tree.draft.tooltip': '只有您看得到草稿。',
  'confluence-table-tree.drafts-toggle.label': '顯示草稿',
  'confluence-table-tree.edit': '編輯',
  'confluence-table-tree.edit-in-confluence': '在 Confluence 中編輯',
  'confluence-table-tree.empty.description': '建立一些會議筆記、產品要求、決策或其他內容，以查看此空間是否已填滿。',
  'confluence-table-tree.empty.title': '這裡目前什麼都沒有，只有潛力無限',
  'confluence-table-tree.error.description': '我們無法向您顯示頁面。請稍後再試一次。',
  'confluence-table-tree.error.row': '無法載入頁面。',
  'confluence-table-tree.error.title': '嗯，這有點奇怪...',
  'confluence-table-tree.friendly-when-created': '已建立',
  'confluence-table-tree.friendly-when-updated': '已更新',
  'confluence-table-tree.share.copied': '已複製到剪貼簿',
  'confluence-table-tree.share.copy-button': '複製',
  'confluence-table-tree.share.subtitle': '分享此連結',
  'confluence-table-tree.share.title': '分享頁面',
  'confluence-table-tree.share.tooltip': '分享',
  'confluence-table-tree.view-profile': '檢視設定檔',
};
